"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFlatMapParallel = asyncFlatMapParallel;
exports.default = void 0;

var _asyncMapParallel = require("../$map/async-map-parallel");

var _asyncIterable = require("../../internal/async-iterable");

async function* asyncFlatMapParallel(iterable, concurrency = 4, func) {
  for await (const item of (0, _asyncMapParallel.asyncMapParallel)(concurrency, func, iterable)) {
    yield* item;
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncFlatMapParallel);

exports.default = _default;